import { createStyles, makeStyles, Theme } from '@material-ui/core';
import commonStyles from 'config/commonStyles';
const styles = makeStyles((theme: Theme) =>
    createStyles({
        ...commonStyles,
        tabsContainer: {
            borderBottom: `1px solid ${theme.palette.grey[300]}`,
            padding: '0px 15px',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 99,
        },
        tableContainer: {
            maxHeight: 'calc(100vh - 210px)',
            minHeight: 500,
            overflow: 'auto',
            '& .MuiTableSortLabel-root': {
                textAlign: 'start',
            },
        },
        eachTabFor4: {
            width: '25%',
            paddingBottom: '16px !important',
        },
        eachTabFor5: {
            width: '20%',
            paddingBottom: '16px !important',
            whiteSpace: 'nowrap',
        },
        accordion: {
            '& tr:first-child td': {
                borderTop: '1px solid rgba(224, 224, 224, 1)',
            },
        },
        expanded: {
            '&$expanded': {
                margin: '0 0 2px 0',
            },
        },
        opacity03: {
            opacity: 0.3,
        },
        dayWithDotContainer: {
            position: 'relative',
        },
        dayWithDot: {
            position: 'absolute',
            height: 0,
            width: 0,
            border: '2px solid',
            borderRadius: 4,
            borderColor: theme.palette.primary.main,
            right: '50%',
            transform: 'translateX(1px)',
            top: '80%',
        },
        priceAmountContainer: {
            position: 'absolute',
            right: '1%',
            marginTop: '-3px',
            marginRight: '2.5px',
        },
        currencyText: {
            color: theme.palette.primary.main,
            fontWeight: '400',
            fontSize: '14px',
            marginRight: '3px',
        },
        currencyAmount: {
            color: theme.palette.primary.main,
            fontWeight: '700',
            fontSize: '24px',
        },
        switchGraphContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '70px',
            margin: '0 53px 0 66px',
        },
        switchBasic: {
            padding: '1px',
            border: '1px solid transparent',
            '&:hover': {
                cursor: 'pointer',
            },
        },
        chartContainer: {
            padding: '15px',
            width: '91%',
            height: '65%',
            position: 'relative',
        },
        chartBottomContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexDirection: 'row',
            backgroundColor: theme.palette.common.white,
            height: '63px',
            borderTop: `1px solid ${theme.palette.grey['300']}`,
            marginTop: '-10px',
            padding: '0 40px',
            marginBottom: 12,
        },
        chartBottomIconText: {
            marginLeft: '12px',
        },
        chartCurrencyText: {
            position: 'absolute',
            fontSize: '13px',
            color: theme.palette.grey['400'],
            top: 18,
        },
        secondDateHistoryText: {
            color: theme.palette.primary.main,
            fontSize: '16px',
            fontWeight: '700',
        },
        textField: {
            borderBottom: '1px solid transparent',
            opacity: 0.75,
        },
        focusedTextField: {
            borderBottom: '1px solid black',
            opacity: 1,
        },
        timePickerContainer: { position: 'absolute', zIndex: 99, top: 100, right: '24%' },
        topContainer: {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            padding: '0px 15px',
            marginTop: 15,
        },
        noBordersHeader: {
            '& td': {
                border: 'none',
            },
        },
        tableHeader: {
            color: theme.palette.action.disabled,
        },
        kpiContainer: {
            marginTop: 15,
            padding: '0px 15px',
        },
        dateContainer: {
            padding: '0px 15px 15px 15px',
        },
        totalAmountValueWrapper: {
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            marginLeft: 5,
        },
        totalAmountExpandButton: {
            padding: 2,
            marginRight: -6,
            color: theme.palette.action.active,
        },
        totalAmountDropdown: {
            position: 'absolute',
            top: 'calc(100% + 6px)',
            left: 0,
            width: '100%',
            boxSizing: 'border-box',
            backgroundColor: theme.palette.common.white,
            borderRadius: 6,
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.12)',
            padding: '10px 12px',
            zIndex: 20,
        },
        totalAmountDropdownRow: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '4px 0',
            fontSize: 13,
        },
        totalAmountDropdownLabel: {
            color: theme.palette.text.primary,
            fontWeight: 500,
            marginRight: 12,
        },
        totalAmountDropdownAmount: {
            color: theme.palette.text.primary,
            fontWeight: 700,
            whiteSpace: 'nowrap',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
        },
        totalAmountDropdownCurrency: {
            color: 'inherit',
            fontWeight: 700,
            fontSize: '14px',
            marginRight: 3,
        },
        totalAmountDropdownRowSummary: {
            borderTop: `1px solid ${theme.palette.grey['300']}`,
            marginTop: 6,
            paddingTop: 8,
        },
        totalAmountDropdownAmountMain: {
            color: theme.palette.primary.main,
        },
        totalAmountDropdownAmountNegative: {
            color: theme.palette.error.main,
        },
        totalAmountDropdownAmountPositive: {
            color: theme.palette.success.main,
        },
        totalAmountDropdownAmountDefault: {
            color: theme.palette.text.secondary,
        },
        collapseRow: {
            '&:hover': {
                backgroundColor: 'unset !important',
            },
        },
        textAccent: {
            fontWeight: 600,
            fontSize: 13,
            color: theme.palette.primary.dark,
        },
        footerText: {
            fontWeight: 700,
            fontSize: 13,
            color: theme.palette.primary.dark,
        },
        textUpper: {
            textTransform: 'uppercase',
        },
        tableContainerGroups: {
            maxHeight: 'calc(100vh - 360px)',
        }
    })
);

export default styles;
